module.exports = __webpack_public_path__ + "img/psql.a4db7c02.png";